import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const HomeIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21.687 11.773 12 2.625l-9.687 9.148 1.374 1.454L5 11.987V20a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-8.013l1.313 1.24zM17 10.098l-5-4.723-5 4.723V19h10z"
      clipRule="evenodd"
    />
  </BaseIcon>
)
